<template>
  <div class="content">
    <div class="export-csv-block">
      <a target="_blank" v-bind:href="csvLink"  class="export-csv">Экспортировать</a>
    </div>

    <DataTable :indexFix="usersPage===1?0:(usersPage-1)*10" :data="users" :keys="usersKeys"></DataTable>
    <Pagination :current="usersPage" :dispatchFn="'getUserList'" :pages="usersTotal" :page="usersPage" :perPage="15" @setpage="setUsersPage" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import DataTable from "../components/views/DataTable";
import Pagination from "../components/Pagination";

export default {

  name: "Users",

  components:{
    DataTable,
    Pagination
  },

  computed:{
    ...mapState(['users','usersKeys','usersTotal','usersPage','csvLink']),
  },

  methods:{
    ...mapActions(['setUsersPage'])
  },

  mounted() {
    this.$store.dispatch('getUserList')
    this.$store.dispatch('getCsvLink')
  }
}
</script>

<style scoped>
.export-csv-block{
  width: 90%;
  margin: 0 auto;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row-reverse;
}
.export-csv{
  background-color: #354394;
  position: relative;
  color: #fff;
  cursor: default;
  border-radius: 9999px;
  border:none;
  padding:3px 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
}
.export-csv:hover{
  cursor: pointer;
}

.content{
  display: block !important;
}
</style>
